/**
 * Company logo component
 * Can be wrapped in a link or displayed standalone
 */

const Logo = ({
  href = '/',
  linkEnabled = false,
  className = '',
  ariaLabel = 'Go to home',
  variant = 'symbol',
}) => {
  // SVG logo content
  const symbol = (
    <svg viewBox="0 0 187 113" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Moment Technology</title>
      <desc>https://moment.com</desc>
      <path
        d="M109.946 37.0528L186.8 0.112269L165.894 66.4135C164.964 69.367 162.853 71.7957 160.071 73.1395L79.8827 111.683C76.6044 113.258 73.0326 110.157 74.13 106.686L82.6088 79.8095C83.6223 76.5899 80.3091 73.7064 77.2685 75.1692L0.400391 112.096L21.3072 45.7945C22.2369 42.841 24.3478 40.4123 27.1298 39.0685L107.318 0.525227C110.596 -1.04954 114.168 2.05101 113.071 5.5225L104.592 32.3985C103.578 35.618 106.892 38.5016 109.932 37.0388L109.946 37.0528Z"
        fill="currentColor"
      />
    </svg>
  )

  const word = (
    <svg viewBox="0 0 474 98" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Moment Technology</title>
      <desc>https://moment.com</desc>
      <path
        d="M143.656 24.7676C164.496 24.7676 178.888 40.231 178.888 61.3428C178.888 82.4548 164.504 97.7832 143.656 97.7832C122.808 97.783 108.297 82.4546 108.297 61.3428C108.297 40.2311 122.816 24.7678 143.656 24.7676ZM327.457 24.7754C351.528 24.7756 360.264 43.7348 360.4 62.5586V65.1113H306.344C307.417 78.4232 315.761 86.4873 327.457 86.4873C336.065 86.4872 343.321 83.1268 345.745 75.4629H359.329C355.433 89.8469 343.592 97.7832 327.593 97.7832C306.889 97.7832 293.032 82.8552 293.032 60.9434C293.032 39.0314 307.553 24.7754 327.457 24.7754ZM459.488 26.5195H472.936V37.543H459.488V74.3828C459.488 81.1028 462.312 84.8711 468.36 84.8711H473.064V96.167H466.344C451.553 96.167 445.904 87.5593 445.904 75.7275V37.543H435.28V26.5195H445.904V10.3828L459.488 4.33496V26.5195ZM98.7683 96.0391H84.5125V16.167H84.24L57.7527 96.0391H41.7527L15.1287 16.167H14.8562V96.0391H0.600342V0.03125L24.0007 0.166992L49.8162 78.959H49.9519L75.3679 0.03125H98.7683V96.0391ZM404.76 24.7754C422.912 24.7755 429.768 36.743 429.768 51.7988V96.0391H416.056V54.0869C416.056 42.527 411.616 36.6074 402.072 36.6074C392.528 36.6075 384.056 45.0794 384.056 62.8232V96.0312H370.208V26.5186H383.921V39.1592C387.553 31.2232 394.009 24.7754 404.76 24.7754ZM259.961 24.7676C277.041 24.7676 284.297 36.7351 284.297 51.791V96.0312H270.585V54.0791C270.585 42.5192 266.417 36.5997 258.081 36.5996C249.745 36.5996 243.024 45.2076 243.024 62.1436V96.0234H229.44V54.0713C229.44 42.5115 226.617 36.591 217.073 36.5908C205.241 36.5908 202.016 48.6956 202.016 62.8076V96.0156H188.169V26.5195H201.873V38.2148C203.489 31.7589 210.209 24.7676 219.753 24.7676C230.513 24.7676 236.96 29.0716 240.192 38.3516C244.36 29.3436 250.409 24.7676 259.961 24.7676ZM143.656 36.1992C130.744 36.1995 122.009 47.4951 122.009 61.3428C122.009 75.1906 130.616 86.3513 143.656 86.3516C156.568 86.3516 165.304 75.0548 165.304 61.3428C165.304 47.6309 156.568 36.1992 143.656 36.1992ZM327.457 35.7988C315.489 35.7988 308.096 43.4629 306.48 54.7588H346.688C345.616 43.735 339.424 35.799 327.457 35.7988ZM188.169 26.5195H188.161L188.169 26.4951V26.5195Z"
        fill="currentColor"
      />
    </svg>
  )

  // Determine which logo variant to render
  // biome-ignore lint/suspicious/noImplicitAnyLet: Bulk suppression as part of biome migration
  let logoContent
  if (variant === 'symbol') {
    logoContent = symbol
  } else if (variant === 'word') {
    logoContent = word
  } else {
    logoContent = (
      <div className="flex gap-1.5">
        <div className="flex-[3]">{symbol}</div>
        <div className="flex-[8]">{word}</div>
      </div>
    )
  }

  // Render with or without link
  if (linkEnabled) {
    return (
      <a
        href={href}
        className={`outline-offset-3 ${className}`}
        aria-label={ariaLabel}
      >
        {logoContent}
      </a>
    )
  }

  return <span className={`inline-block ${className}`}>{logoContent}</span>
}

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default Logo
